import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-payment-complete',
    templateUrl: '../svgs/PaymentCompleted.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--payment-complete'
    }
})
export class TellerOnlineIconPaymentComplete {
}